import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { PortionDebugViewButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { createSeparationCountSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import ids from 'Components/Worksheets/QestIds';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { Phase } from '../../types';
import {
  ResultsPageSection,
  SeparationSectionGroup,
  SievePortionPreparationSection,
  SpecimenPreparationPageSection,
  TestPreparationPageSection,
  WashingPageSection,
} from './Sections';
import { PortionSievingPageSection } from './Sections/Sieving';

const isDevMode = process.env.REACT_APP_ENABLE_DEV_MODE === 'true';
const qestIds = [ids.psdSieveAnalysis.AS_1289_3_6_1.Rev2009];

let As1289_3_6_1_PsdSieveAnalysisWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const washingPhase = useSelector(createWorksheetSelector!('Preparation.WashingPhase')) as Phase;

  const isWholePortionSeparated = useSelector(
    pipe(createSeparationCountSelector(createWorksheetSelector!), (c) => c !== 0)
  );

  return (
    <>
      {isDevMode && (
        <PageSection>
          <PortionDebugViewButton />
        </PageSection>
      )}

      <TestPreparationPageSection />
      <SpecimenPreparationPageSection />
      <SievePortionPreparationSection />

      <NamePrefixModifier appendNamePrefix={`WholePortion`}>
        {washingPhase === Phase.WholePortion && <WashingPageSection />}
        {isWholePortionSeparated ? <SeparationSectionGroup /> : <PortionSievingPageSection />}
      </NamePrefixModifier>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <ResultsPageSection />

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

As1289_3_6_1_PsdSieveAnalysisWorksheet.qestIds = qestIds;
As1289_3_6_1_PsdSieveAnalysisWorksheet = withInjectedProps(As1289_3_6_1_PsdSieveAnalysisWorksheet);

export default As1289_3_6_1_PsdSieveAnalysisWorksheet;
export { As1289_3_6_1_PsdSieveAnalysisWorksheet };
